module.exports = __webpack_public_path__ + "static/media/SourceSansPro-Regular.5182da42.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/Source_Sans_Pro/SourceSansPro-Regular.ttf
// module id = 76
// module chunks = 0